import React from 'react';
import { List } from 'immutable';
import { EmailRecipient } from 'flow/types/TicketEventData';
import { TypedMap } from 'flow/types/TypedMap';
import useAppContext from 'flow/hooks/useAppContext';
import EmailIdentity from 'flow/components/tickets/event-item/Email/EmailIdentity';

interface Props {
    identities?: List<TypedMap<EmailRecipient>>;
    titlei18Key: string;
    highlightName?: boolean;
}

const MenuItemEmailIdentities = ({
    identities,
    titlei18Key,
    highlightName,
}: Props) => {
    const { i18next } = useAppContext();

    if (!identities || identities.size === 0) {
        return null;
    }

    return (
        <div className="flex w-full py-1.5 hover:rounded hover:bg-gray-200 dark:bg-gray-200 dark:hover:bg-gray-400">
            <div className="flex cursor-default gap-x-3 px-2 text-sm">
                <span className="flex min-w-8 justify-end text-gray-500 lowercase">
                    {i18next.t(titlei18Key)}
                </span>
                <div className="flex flex-col gap-x-1">
                    {identities.toArray().map((identity) => (
                        <div key={`eii-${identity.get('address')}`}>
                            <EmailIdentity
                                identity={identity}
                                highlightName={highlightName}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MenuItemEmailIdentities;
